module.exports = __webpack_public_path__ + "static/ronn-71358916c59de607eb825e0f35df425d.jpg";